import { FC } from 'react'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { TextField } from '@mui/material'
import { IRpLimit } from '../../prp2boxApi/limits'
import { formPropsDrawerCrud } from '../../constants/formPropsDrawerCrud'
import { TRpLimitFormData } from './schema'

const limitFields: Partial<Record<keyof IRpLimit, string>> = {
  name: 'Имя',
  min: 'Минимум',
  max: 'Максимум',
  maxPayout: 'Максимальная выплата',
}

type TRpLimitFormBaseProps = {
  register: UseFormRegister<TRpLimitFormData>
  errors: FieldErrors<TRpLimitFormData>
}

const RpLimitFormBase: FC<TRpLimitFormBaseProps> = (props) => {
  const fieldProps = {
    ...formPropsDrawerCrud,
  }

  const { register, errors } = props

  return (
    <>
      <TextField
        {...fieldProps}
        {...register('name')}
        label={limitFields.name}
        error={!!errors.name}
        helperText={errors.name?.message}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        {...fieldProps}
        {...register('min')}
        label={limitFields.min}
        error={!!errors.min}
        helperText={errors.min?.message}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        {...fieldProps}
        {...register('max')}
        label={limitFields.max}
        error={!!errors.max}
        helperText={errors.max?.message || 'Пустое значение означает без лимита'}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        {...fieldProps}
        {...register('maxPayout')}
        label={limitFields.maxPayout}
        error={!!errors.maxPayout}
        helperText={errors.maxPayout?.message || 'Пустое значение означает без лимита'}
        InputLabelProps={{ shrink: true }}
      />
    </>
  )
}

export default RpLimitFormBase
